import React, { useState } from 'react'
import styled from 'styled-components'
import { withTranslation } from 'react-i18next'
import { Formik, ErrorMessage } from 'formik'

import {
  PrimaryProgressButton,
  SecondaryButton
} from '@stacc/flow-ui-components'
import { Colors } from '@stacc/flow-ui-components'
import { RadioButtons, TextArea } from '@stacc/flow-ui-components'
import { AssessmentFormProps, TaskData } from '../../types/customerDeclaration'

const FormGroup = styled.div`
  padding: 20px 0px 0px 0px;
`

const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse; /*Primarybutton is placed to the right but still triggered on enter key*/
`

const Error = styled.div`
  color: ${Colors.Ferrari};
`

const AssessmentForm = ({
  onSave,
  onSubmit,
  riskClassOptions,
  t,
  taskdata
}: AssessmentFormProps) => {
  const [isSaving, setIsSaving] = useState(false)

  function handleSave(
    e: React.MouseEvent<Element, MouseEvent>,
    values: TaskData
  ) {
    e.preventDefault()
    setIsSaving(true)
    onSave(values, () => {
      setIsSaving(false)
    })
  }

  return (
    <div>
      <Formik
        initialValues={{
          riskClass: taskdata?.riskClass,
          comment: taskdata?.comment
        }}
        validate={(values: TaskData) => {
          const errors: { riskClass: string } | any = {}
          if (!values.riskClass) {
            errors.riskClass = t('Please provide a risk class')
          }
          return errors
        }}
        onSubmit={(values: TaskData, { setSubmitting }) => {
          onSubmit(values, () => {
            setSubmitting(false)
          })
        }}
      >
        {({ values, handleChange, handleSubmit, handleBlur, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <FormGroup>
              <h6>{t('RiskClass')}</h6>
              <RadioButtons
                disabled={isSaving || isSubmitting}
                options={riskClassOptions}
                name="riskClass"
                onChange={handleChange}
                checkedValue={values.riskClass}
              />
            </FormGroup>
            <FormGroup>
              <TextArea
                name="comment"
                rows={5}
                cols={35}
                placeholder={t('Optionally reasons')}
                defaultValue={values.comment}
                onBlur={handleBlur}
                onChange={handleChange}
                disabled={isSaving || isSubmitting}
              />
            </FormGroup>
            <FormGroup>
              <ErrorMessage name="riskClass" component={Error} />
            </FormGroup>
            <FormGroup>
              <ButtonGroup>
                <PrimaryProgressButton
                  type="submit"
                  isLoading={isSubmitting || isSaving}
                >
                  {t('Complete')}
                </PrimaryProgressButton>
                <SecondaryButton
                  disabled={isSaving || isSubmitting}
                  onClick={(e: React.MouseEvent) => handleSave(e, values)}
                >
                  {t('Save and close')}
                </SecondaryButton>
              </ButtonGroup>
            </FormGroup>
          </form>
        )}
      </Formik>
    </div>
  )
}

export default withTranslation()(AssessmentForm)
